// eslint-disable-next-line no-unused-vars
import React, { useEffect, useMemo } from 'react';
import { node } from 'prop-types';
import { createContext, useContextSelector } from 'use-context-selector';
import noop from 'lodash/noop';
import useSWR from 'swr';

import { API_USER_NOTIFICATIONS } from 'Constants';
import useFetch from 'Hooks/useFetch';
import { UserContext } from 'Contexts/UserContext';

export const NotificationsContext = createContext({
  data: [],
  loading: false,
  onMarkAsRead: noop
});

const NotificationsProvider = ({ children }) => {
  const response = useSWR(`${API_USER_NOTIFICATIONS}?only_unread_messages=true`);
  const fetch = useFetch();
  const loggedIn = useContextSelector(UserContext, data => data.data.loggedIn);
  useEffect(() => {
    if (loggedIn) {
      response.mutate();
    }
  }, [loggedIn]);

  const handleOnRead = async id => {
    const d = await fetch(`${API_USER_NOTIFICATIONS}/${id}/read`, {
      method: 'POST'
    });
    response.mutate(response.data.filter(item => item.messageId !== id), true);
    return d;
  };

  const memoizedValue = useMemo(() => ({
    data: response.data || [],
    loading: response.isValidating,
    onMarkAsRead: handleOnRead,
  }), [response]);

  return (
    <NotificationsContext.Provider value={ memoizedValue }>
      { children }
    </NotificationsContext.Provider>
  );
};

NotificationsProvider.propTypes = {
  children: node
};

export default NotificationsProvider;
